export enum sellerEnum {
    TYPE_PF = 'PF',
    TYPE_PJ = 'PJ',
    FORM_PERSONAL_DATA = 'PERSONAL_DATA',
    FORM_PROPERTY_DIVISION = 'PROPERTY_DIVISION',
    STATUS_SUBMITTED = 'SUBMITTED',
    STATUS_IN_PROGRESS = 'IN_PROGRESS',
    STATUS_NOT_STARTED = 'NOT_STARTED'
}